<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="手机号码">
                  <el-input style="width: 200px;" v-model="queryForm.userMobile"></el-input>
              </el-form-item>
              <el-form-item label="订单ID">
                  <el-input style="width: 200px;" v-model="queryForm.orderId"></el-input>
              </el-form-item>
              <el-form-item label="是否已赠送">
<!--                  <el-input  v-model="queryForm.status"></el-input>-->
                  <el-select v-model="queryForm.status" placeholder="请选择" size="small" clearable style="width: 200px;">
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopThirdOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopThirdOrder"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopThirdOrder(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopThirdOrder(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopThirdOrderList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopThirdOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopThirdOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userMobile"
        label="手机号码"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderId"
        label="订单ID"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单金额"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="是否已赠送"
      >
          <template slot-scope="scope">
              {{scope.row.status == 1 ? '是' : '否'}}
          </template>
      </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="giveUserScore"
        label="赠送用户贡献值"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="error"
        label="错误信息"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopThirdOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopThirdOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteShopThirdOrder(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopThirdOrderStates[shopThirdOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopThirdOrder"
          ref="shopThirdOrderForm"
          :rules="rules"
          label-width="140px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="手机号码"
            prop="userMobile"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdOrder.userMobile"
              :disabled="shopThirdOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单ID"
            prop="orderId"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdOrder.orderId"
              :disabled="shopThirdOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单金额"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopThirdOrder.orderPrice"
              :disabled="shopThirdOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否已赠送"
            prop="status"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopThirdOrder.status"-->
<!--              :disabled="shopThirdOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                v-model="shopThirdOrder.status"
                placeholder="请选择"
                clearable
                style="width: 200px;"
                :disabled="shopThirdOrderState == 'check'"
              >
                <el-option
                  label="是"
                  :value="1"
                >
                </el-option>
                  <el-option
                      label="否"
                      :value="0"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
            <el-form-item
                label="赠送用户贡献值"
                prop="giveUserScore"
            >
                <el-input
                    size="small"
                    style="width: 200px;"
                    v-model="shopThirdOrder.giveUserScore"
                    :disabled="shopThirdOrderState == 'check'"
                ></el-input>
            </el-form-item>
          <el-form-item
            label="错误信息"
            prop="error"
          >
            <el-input
                style="width: 200px;"
              size="small"
              v-model="shopThirdOrder.error"
              :disabled="shopThirdOrderState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopThirdOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopThirdOrderList();
                    this.getShopThirdOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopThirdOrderList();
                    this.getShopThirdOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     userMobile: '', //手机号码
                     orderId: '', //订单ID
                     orderPrice: '', //订单金额
                     status: '', //1已赠送  0未赠送
                     error: '', //
                    giveUserScore: '',
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopThirdOrderState: 'add',
                shopThirdOrderStates: {
                    add: '新建三方订单',
                    check: '查看三方订单',
                    edit: '修改三方订单'
                },

                multipleSelection: [],
                shopThirdOrderList: [],
                shopThirdOrder: {
                    id: '', //ID
                    userMobile: '', //手机号码
                    orderId: '', //订单ID
                    orderPrice: '', //订单金额
                    status: '', //1已赠送  0未赠送
                    error: '', //
                    giveUserScore: '',
                },
                btnLoading: false,

                rules: {
                    userMobile: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }],
                    orderId: [{ required: true, message: '订单ID不能为空', trigger: 'blur' }],
                    orderPrice: [{ required: true, message: '订单金额不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '是否已赠送不能为空', trigger: 'blur' }],
                    error: [{ required: true, message: '错误信息不能为空', trigger: 'blur' }],
                    giveUserScore: [{ required: true, message: '赠送贡献值不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopThirdOrderList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopThirdOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopThirdOrderList = [];
            },
            resetDialog() {
                this.shopThirdOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userMobile: '', //手机号码
                      orderId: '', //订单ID
                      orderPrice: '', //订单金额
                      status: '', //1已赠送  0未赠送
                      error: '', //
                    giveUserScore: '',
                };
                this.getShopThirdOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopThirdOrder = {
                      id: '', //ID
                      userMobile: '', //手机号码
                      orderId: '', //订单ID
                      orderPrice: '', //订单金额
                      status: '', //1已赠送  0未赠送
                      error: '', //
                    giveUserScore: '',
                };
            },
            submitForm() {
                if (this.shopThirdOrderState == 'add') {
                    this.$refs.shopThirdOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/thirdorder/add`,{ ...this.shopThirdOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopThirdOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopThirdOrderState == 'edit') {
                    this.$refs.shopThirdOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/thirdorder/edit`,{ ...this.shopThirdOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopThirdOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopThirdOrder() {
                this.showDialog = true;
                this.shopThirdOrderState = 'add';
            },
            checkShopThirdOrder(shopThirdOrderId) {
                console.log(shopThirdOrderId);
                this.currentShopThirdOrderId = shopThirdOrderId;

                this.getShopThirdOrderById();
                this.showDialog = true;
                this.shopThirdOrderState = 'check';
            },
            editShopThirdOrder(shopThirdOrderId) {
                console.log('shopThirdOrder', shopThirdOrderId);
                if (shopThirdOrderId) {
                    this.currentShopThirdOrderId = shopThirdOrderId;
                    this.getShopThirdOrderById();
                } else {
                    this.shopThirdOrder = { ...this.shopThirdOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopThirdOrderState = 'edit';
            },
            deleteShopThirdOrder(shopThirdOrderId) {
                let ids = '';
                if (shopThirdOrderId) {
                    ids = shopThirdOrderId;
                } else {
                    ids = this.multipleSelection.map((shopThirdOrder) => shopThirdOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/thirdorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopThirdOrderList();
                                this.getShopThirdOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopThirdOrderList() {
                this.resetShopThirdOrderList();
                this.getShopThirdOrderList();
            },
            getShopThirdOrderList(query = {}) {
                this.loading = true;
                get(`/shop/thirdorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopThirdOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopThirdOrderById() {
                get(`/shop/thirdorder/get`,{ id: this.currentShopThirdOrderId }).then((res) =>{
                    if(res.success){
                      this.shopThirdOrder = { ...this.shopThirdOrder, ...res.shopThirdOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopThirdOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/thirdorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/thirdorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/thirdorder/importData`,formData);
              this.refreshShopThirdOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopThirdOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopThirdOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>